import React from 'react';
import { connect } from 'react-redux';
import CKEditor from 'react-ckeditor-component';
import ArrowButton from '../../button-arrow';
import { saveTextContent } from '../../../../actions/content';
import CKEditorConfig from '../../../../data/CKEditor';

import './styles.css';

class InlineCKEditor extends React.Component {
  state = {
    content: '',
    identifier: ''
  };

  updateContent = (newContent) => {
    this.setState({
      content: newContent
    });
  };

  onSaveContent = () => {
    this.props.dispatch(saveTextContent(this.state.identifier, this.state.content))
      .then(() => {
        if (typeof this.props.onContentSaved === 'function') {
          this.props.onContentSaved();
        }
      });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.identifier && nextProps.contents) {
      this.setState({
        identifier: nextProps.identifier,
        content: this.state.content || nextProps.contents.body || ''
      });
    }
  }

  componentWillMount() {
    this.setState({
      identifier: this.props.identifier,
      content: this.props.contents ? this.props.contents.body : ''
    });
  }

  render() {
    const { content } = this.state;
    const { editContent, activeClass, config } = this.props;
    const renderedContent = content ? <div dangerouslySetInnerHTML={{__html: content}}/> : '';

    return (
      <div className="inline-editor">
        {editContent ? (
          <div>
            <CKEditor
              content={content}
              activeClass={activeClass}
              scriptUrl="/api/ckeditor/ckeditor.js"
              config={{
                ...CKEditorConfig,
                ...config
              }}
              events={{
                change: event => this.updateContent(event.editor.getData())
              }}
            />
            <div className="mg-top-40">
              <ArrowButton
                arrow={false}
                submit={false}
                onClick={this.onSaveContent}
              >
                Save
              </ArrowButton>
            </div>
          </div>
        ) : renderedContent}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  editContent: state.viewConfig.editContent
});

export default connect(mapStateToProps)(InlineCKEditor);



// WEBPACK FOOTER //
// ./src/components/common/editor/inline-editor/index.jsx